import { BASE_API_URL } from '../utils/app-constants';

export const COMPANY_URL = `${BASE_API_URL}/company`;
export const ORGANISATION_TYPE_URL = `${BASE_API_URL}/organisationtype`;
export const ORGANISATION_URL = `${BASE_API_URL}/organisation`;
export const ORGANISATION_ASPECT_URL = `${BASE_API_URL}/organisationaspect`;
export const USER_URL = `${BASE_API_URL}/user`;
export const ROLE_URL = `${BASE_API_URL}/role`;
export const PERIOD_URL = `${BASE_API_URL}/period`;
export const SCORECARD_URL = `${BASE_API_URL}/scorecard`;
export const SCORECARDS_URL = `${BASE_API_URL}/scorecards`;
export const PERSPECTIVE_URL = `${BASE_API_URL}/perspective`;
export const OBJECTIVE_URL = `${BASE_API_URL}/objective`;
export const KPI_URL = `${BASE_API_URL}/kpi`;
export const LOGIN_URL = `${BASE_API_URL}/auth/login`;
export const TOKEN_REFRESH_URL = `${BASE_API_URL}/auth/token/refresh`;
export const PASSWORD_RESET_URL = `${BASE_API_URL}/auth/password/recover`;
export const SETTINGS_URL = `${BASE_API_URL}/settings`;
export const SCORECARD_KPI_TARGET = `${BASE_API_URL}/scorecardkpitarget`;
export const INITIATIVES_URL = `${BASE_API_URL}/initiative`;
export const TASKS_URL = `${BASE_API_URL}/task`;
export const TASKS_OWNER_URL = `${BASE_API_URL}/task/owner`;
export const STRATEGYMAP_URL = `${BASE_API_URL}/strategymap`;
export const USER_REVIEW_URL = `${BASE_API_URL}/userreview`;
export const USER_REVIEWERS_URL = `${BASE_API_URL}/userreview/user`;
export const GROUPS_URL = `${BASE_API_URL}/user-group`;
export const MATRIX_URL = `${BASE_API_URL}/scoring-matrix`;
export const KPI_SEARCH_URL = `${BASE_API_URL}/kpisearch`;
export const DELETE_KPI_URL = `${BASE_API_URL}/delete_kpi`;
export const MEASURES_URL = `${BASE_API_URL}/measures`;
export const MEASURES_INSERT_URL = `${BASE_API_URL}/insert_measures`;
export const MEASURES_UPDATE_URL = `${BASE_API_URL}/update_measures`;
export const GET_MEASURES_URL = `${BASE_API_URL}/get-measures`;
export const CANCEL_APPROVAL_URL = `${BASE_API_URL}/delete-request`;
export const SEND_EMAIL_URL = `${BASE_API_URL}/send-email`;
export const ADA_REFERENCE_URL = `${BASE_API_URL}/insert_ada_reference`;
export const MEASURES_EVIDENCE_URL = `${BASE_API_URL}/insert_evidence`;
export const GET_STAFF_URL = `${BASE_API_URL}/current_staff`;
export const SCORECARD_KPI_URL = `${BASE_API_URL}/scorecards`;
export const KPI_TARGET = `${BASE_API_URL}/kpitarget`;